import { Checkbox } from "@chakra-ui/react";

export default function DataCollectionPage() {
  return (
    <div className="page">
      <h1>Data Preprocessing</h1>
      <Checkbox>Checkbox</Checkbox>
    </div>
  );
}
